import { AppThunkAction } from '../../reducers';
import { CreateSector, UpdateSector } from '../../../models/Entities/Turnero';
import { ErrorType } from '../../../models/HttpError';

// services
import * as Services from '../../../services/Turnero-Sectores.Services';

// actions
import * as ActionEvents from '../../actions/Turnero-Sectores.Actions';
import {
    TurneroSectoresCreateFailureAction,
    TurneroSectoresCreateRequestAction,
    TurneroSectoresCreateSuccessAction,
    TurneroSectoresDeleteFailureAction,
    TurneroSectoresDeleteRequestAction,
    TurneroSectoresDeleteSuccessAction,
    TurneroSectoresGetAllFailureAction,
    TurneroSectoresGetAllRequestAction,
    TurneroSectoresGetAllSuccessAction,
    TurneroSectoresGetByIdFailureAction,
    TurneroSectoresGetByIdRequestAction,
    TurneroSectoresGetByIdSuccessAction,
    TurneroSectoresGetEstadisticasFailureAction,
    TurneroSectoresGetEstadisticasRequestAction,
    TurneroSectoresGetEstadisticasSuccessAction,
    TurneroSectoresUpdateFailureAction,
    TurneroSectoresUpdateRequestAction,
    TurneroSectoresUpdateSuccessAction
} from '../../actions/Turnero-Sectores.Actions';

type KnownAction =
    | TurneroSectoresGetAllRequestAction
    | TurneroSectoresGetAllSuccessAction
    | TurneroSectoresGetAllFailureAction
    | TurneroSectoresCreateRequestAction
    | TurneroSectoresCreateSuccessAction
    | TurneroSectoresCreateFailureAction
    | TurneroSectoresGetByIdRequestAction
    | TurneroSectoresGetByIdSuccessAction
    | TurneroSectoresGetByIdFailureAction
    | TurneroSectoresUpdateRequestAction
    | TurneroSectoresUpdateSuccessAction
    | TurneroSectoresUpdateFailureAction
    | TurneroSectoresDeleteRequestAction
    | TurneroSectoresDeleteSuccessAction
    | TurneroSectoresDeleteFailureAction
    | TurneroSectoresGetEstadisticasRequestAction
    | TurneroSectoresGetEstadisticasSuccessAction
    | TurneroSectoresGetEstadisticasFailureAction;

export const actionCreators = {
    GetSectores: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SECTORES_GET_ALL_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SECTORES_GET_ALL_REQUEST
        });

        Services.GetSectores(token)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_GET_ALL_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_GET_ALL_FAILURE,
                    error
                });
            });
    },
    CreateSector: (payload: CreateSector): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SECTORES_CREATE_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SECTORES_CREATE_REQUEST,
            payload
        });

        Services.CreateSectorRequest(token, payload)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_CREATE_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_CREATE_FAILURE,
                    error
                });
            });
    },
    GetSectorById: (sectorId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SECTORES_GET_BY_ID_FAILURE,
                sectorId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SECTORES_GET_BY_ID_REQUEST,
            sectorId
        });

        Services.GetSectorById(token, sectorId)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_GET_BY_ID_SUCCESS,
                    sectorId,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_GET_BY_ID_FAILURE,
                    sectorId,
                    error
                });
            });
    },
    UpdateSector: (id: number, payload: UpdateSector): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SECTORES_UPDATE_FAILURE,
                id,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SECTORES_UPDATE_REQUEST,
            id,
            payload
        });

        Services.UpdateSectorRequest(token, id, payload)
            .then(() => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_UPDATE_SUCCESS,
                    id,
                    payload: { ...payload, id }
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_UPDATE_FAILURE,
                    id,
                    error
                });
            });
    },
    DeleteSector: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SECTORES_DELETE_FAILURE,
                id,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SECTORES_DELETE_REQUEST,
            id
        });

        Services.DeleteSector(token, id)
            .then(() => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_DELETE_SUCCESS,
                    payload: id
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_DELETE_FAILURE,
                    id,
                    error
                });
            });
    },
    GetEstadisticasSector: (sectorId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SECTORES_GET_ESTADISTICAS_FAILURE,
                sectorId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SECTORES_GET_ESTADISTICAS_REQUEST,
            sectorId
        });

        Services.GetEstadisticasSector(token, sectorId)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_GET_ESTADISTICAS_SUCCESS,
                    sectorId,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SECTORES_GET_ESTADISTICAS_FAILURE,
                    sectorId,
                    error
                });
            });
    }
};
